import * as React from "react";
import { Breakpoint,styled } from "@mui/material/styles";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#005EB8", color: "#F5F5F5" }} {...other}>
            {children}
        </DialogTitle>
    );
};

type ModalProps = {
    modalTitle: string;
    children: React.ReactNode;
    isOpen: boolean;
    onClose: Function;
    footerAction: React.ReactNode;
    modalSize: Breakpoint;
    dialogHeight: string;
};

const CustomizedDialogs = (props: ModalProps) => {

    const [scroll] = React.useState<DialogProps["scroll"]>("paper");

    return (
        <>
            <BootstrapDialog
                maxWidth={props.modalSize}
                fullWidth = {true}
                onClose={() => props.onClose}
                aria-labelledby="customized-dialog-title"
                open={props.isOpen}
                sx={{ minWidth: "500px" }}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={() => props.onClose}>
                    {props.modalTitle}
                </BootstrapDialogTitle>

                <DialogContent dividers={scroll === "paper"}  style={{height:props.dialogHeight}}>
                    {props.children}
                </DialogContent>

                <DialogActions>
                    {props.footerAction}
                </DialogActions>

            </BootstrapDialog>
        </>
    );
};
export default CustomizedDialogs;